import { VOInstrument, VOMelodyNoteLite } from "../model/DataStructure.js";

export interface InstrumentOptions {
    context: AudioContext;
    instrument: VOInstrument;
    volume?: number;
}

export class Instrument {

    public instrument: VOInstrument;

    /**
     * @see https://github.com/Tonejs/Tone.js/blob/dev/Tone/instrument/Sampler.ts
     */
    private _sampler: Tone.Sampler = null;
    private _options: InstrumentOptions;
    private _urls: { [note: string]: AudioBuffer };

    constructor(options: InstrumentOptions) {
        options = e5.object.merge(
            {
                volume: options.instrument.volume
            },
            options);
        this._options = options;
        this.instrument = options.instrument;

        var urls: { [note: string]: AudioBuffer } = {};
        for (var t of this._options.instrument.tones) {
            urls[t.note] = t.sound.buffer;
        }
        this._urls = urls;

        this._sampler = new Tone.Sampler({
            urls: this._urls,
            release: 0.05//Default 0.1
        });

        this._sampler.volume.value = Tone.gainToDb(this._options.volume);
        this._sampler.toDestination();
    }

    public stop(): void {
        /**
         * Fixed in Tone.js minfied code :(
         * 
         * @see https://github.com/Tonejs/Tone.js/blob/master/Tone/instrument/Sampler.ts
         * @see https://github.com/Tonejs/Tone.js/blob/b3f1e1722395fb50e9292ce6b50aac5857d247e5/Tone/source/OneShotSource.ts 
         * 
         * triggerRelease() should not clear the active sources immediately!
         * WRONG: this._activeSources.set(midi, []);
         */
        // (this._synth as any)._activeSources.forEach((sources: any) => {
        //     sources.forEach((source: Tone.Source) => {
        //         source.fadeOut = 0.5;
        //         source.stop();
        //     });
        // });

        this._sampler.releaseAll(0);
    }

    public trigger(note: VOMelodyNoteLite, time: number = 0): void {
        // if (time <= 0) {
        // time = Tone.Transport.seconds + 0.05;
        // }

        this._sampler.triggerAttackRelease(note.name, note.dur, time, note.velocity);
    }
}